import React from "react";
import "./style.css";
import CustomChip from "../general/chips";
import { FormattedMessage } from "react-intl";

const TableFilters = ({ activeFilters, setActiveFilters, filtersList }) => {

  return (
    <div className="preCog-doc-list-body-row vaporTags">
      {filtersList.map((filter, index) =>
        (<CustomChip
          key={`filter_${index}`}
          description={<FormattedMessage id={`preCog.filters.${filter}`}/>}
          active={activeFilters?.find(el => el === filter)?.length > 0 }
          onClick={() => {
            let currentIndex = activeFilters?.findIndex(el => el === filter);
            let newFilters = [];
            if (currentIndex === -1 || !activeFilters) {
              newFilters.push(filter);
              newFilters = activeFilters ? activeFilters.concat(newFilters) : newFilters;
            } else {
              activeFilters.map(el => el !== filter ? newFilters.push(el) : null);
            }
            setActiveFilters(newFilters);
          }}
        />))}
    </div>
  );
};

export default TableFilters;
